import React, { useState } from 'react';
import { Anchor, Drawer, Button } from 'antd';

import './common.css'

const { Link } = Anchor;

function LinestickerHeader() {

    const [visible, setVisible] = useState(false);
    const showDrawer = () => {
        setVisible(true);
    };
    const onClose = () => {
        setVisible(false);
    };

    return (
        <div className="container-fluid">
            <div className="outsideHeader">
                <div className="logo">
                    <strong><a href="htt://">「TUT虛擬數位形象大使」徵稿票選活動</a></strong>
                </div>
                <div className="pcVisible">
                    <Anchor targetOffset="10">
                        <Link href="#index" title="活動目的" />
                        <Link href="#method" title="徵選辦法" />
                        <Link href="#award" title="徵稿獎勵" />
                        <Link href="#signup" title="線上報名" />
                        <Link href="#survey" title="票選抽獎" />
                    </Anchor>
                </div>
                <div className="mobileVisible">
                    <Button type="primary" onClick={showDrawer}><i className="fas fa-bars"></i></Button>
                    <Drawer
                        title="TUT徵稿票選活動"
                        placement="right"
                        closable={false}
                        onClose={onClose}
                        visible={visible}
                    >
                        <Anchor targetOffset="10">
                            <Link href="#index" title="活動目的" />
                            <Link href="#method" title="徵選辦法" />
                            <Link href="#award" title="徵稿獎勵" />
                            <Link href="#signup" title="線上報名" />
                            <Link href="#survey" title="票選抽獎" />
                        </Anchor>
                    </Drawer>
                </div>

            </div>
        </div>
    )

}


export default LinestickerHeader